import { type FunctionalComponent, h } from '@stencil/core';
import EventEmitterComponent from '../event-emitter-component/event-emitter-component';

interface IConversationalSearchDeatilsHeader {
  title: string;
  badgeText?: string | number;
  isBannerVariant?: boolean;
  isParentData?: boolean;
  query: string;
  size: string;
  tag: string;
  url?: string;
  category?: string;
  categoryLocalized?: string;
}

export const ConversationalSearchDeatilsHeader: FunctionalComponent<
  IConversationalSearchDeatilsHeader
> = (props) => {
    const bannerEventSuffix = props.isBannerVariant ? ' From Banner' : '';
    const parentEventSuffix = props.isParentData ? ' Parent' : '';
    const categoryEventPrefix = props?.category ? `${props.category} ` : '';
    const eventCategory = `${categoryEventPrefix}Hierarchy${parentEventSuffix}${bannerEventSuffix}`;
    const textElement = <strong>{props.title}</strong>;
    const linkElement = (
      <EventEmitterComponent
        eventName='conversational-search:ga-suggestion'
        isRightClickActive={true}
        suggestionName={props.title}
        category={eventCategory}
        url={props.url}
        keyword={props.query}
      >
        <qds-web-title-link
          text={props.title}
          size={props.size}
          tag={props.size}
          href={props.url}
          target="_blank"
          icon-name="chevron-right"
        />
      </EventEmitterComponent>
    );

    return (
      props.title && (
        <section class="conversational-search-details-header">
          {props.url ? linkElement : textElement}
          {props?.badgeText ? '' : /* Add qds-badge from wave 8 in future */ ''}
        </section>
      )
    );
};
